$.validator.setDefaults({
    errorClass: "",
    validClass: "",
    //errorElement: "span",
    highlight: function ( element, errorClass, validClass ) {
        $( element ).addClass("is-invalid").removeClass( "is-valid" );
        $(element.form).find("[data-valmsg-for=" + element.id + "]").addClass("invalid-feedback");
        // $( element ).next( "span" ).addClass( "csc-helper-text" );
    },
    unhighlight: function ( element, errorClass, validClass ) {
        $( element ).removeClass( "is-invalid" );
        $(element.form).find("[data-valmsg-for=" + element.id + "]").removeClass("invalid-feedback");
        // $( element ).addClass("is-valid").removeClass( "is-invalid" );
        // $( element ).next( "span" ).addClass( "csc-helper-text" );
    }
});